import { supabase, Database } from '@cleanpro/common-ui';

type UserRole = Database['public']['Enums']['user_role'];

/**
 * Role-Based Access Control (RBAC) service
 * Now backed by Clerk JWT claims via Supabase function get_user_role().
 */
export class RoleService {
  /**
   * Get role for the current authenticated user (Clerk JWT backed).
   * userId is ignored; kept for signature compatibility.
   */
  async getUserRole(_userId?: string): Promise<{ role?: UserRole; error?: string }> {
    try {
      const { data, error } = await supabase.rpc('get_user_role');

      if (error) {
        return { error: error.message };
      }

      return { role: data as UserRole };
    } catch (error) {
      console.error('Failed to get user role:', error);
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  }

  /**
   * Check if user has required role (uses current session).
   */
  async hasRole(requiredRole: UserRole): Promise<boolean> {
    const { role, error } = await this.getUserRole();
    if (error || !role) return false;
    return role === requiredRole;
  }

  /**
   * Check if user has any of the required roles (uses current session).
   */
  async hasAnyRole(requiredRoles: UserRole[]): Promise<boolean> {
    const { role, error } = await this.getUserRole();
    if (error || !role) return false;
    return requiredRoles.includes(role);
  }
}